import { useMainStore } from "@/store";
import { useUserStore } from "@/store/modules/user";

const verificateDuplicateUser = async () => {
  const userStore = useUserStore();
  if (userStore.getShouldCallDuplicatedUser) {
    await userStore.getIsDuplicateUser();
  }
};

export default (role) => {
  return async (to, from, next) => {
    const mainStore = useMainStore();
    const userStore = useUserStore();

    if (!mainStore.getInitFetchDone) {
      await mainStore.initFetch();
    }

    const user = userStore.getCurrentUser;
    if (!user) {
      return next({ path: "/redirection" });
    }

    await verificateDuplicateUser();

    switch (role) {
      case "admin":
        return user.isRoleAdmin() || user.isRoleSuperAdmin()
          ? next()
          : next({ path: "/redirection" });
      case "reviewer":
        return user.isRoleReviewer() ? next() : next({ path: "/redirection" });
      case "candidate":
        return next();
      default:
        return next({ path: "/candidate" });
    }
  };
};
